import { createAction } from "@reduxjs/toolkit";

import { ApiErrorProps } from "../../../types/ApiErrorType";

const initialState: ApiErrorProps = {
  httpCode: null,
  errorCode: "",
  errorMessage: "",
  errorStatus: false,
  errors: null,
  modalTitle: "Something <br> went wrong",
  modalDescription:
    "Please try again. If the problem persists, please contact us.",
  ctaPrimaryBtnLabel: "Try again",
  ctaSecondaryBtnLabel: "Contact us",
  multiButton: false,
  isCloseIconEnabled: true,
  contactNumber: "+34952010057",
};

export const setApiError = createAction<ApiErrorProps>("apiError/setApiError");
export const clearApiError = createAction("apiError/clearApiError");

export const mergeDefaultProps = (payload: ApiErrorProps) => ({
  ...initialState,
  ...payload,
});
